type GetWorkspaceSelectionBarZIndexClassParams = {
  isWorkspaceNavPushMode: boolean;
  ui2026: boolean;
};

/**
 * Z-index class for the workspace selection bar portal shell.
 *
 * `z-portal` paints above the expanded MainSideNav rail (`z-50`). Use `z-40` whenever
 * ui2026 chrome is active or the left nav is in push mode so the bar sits behind the rail.
 */
export const getWorkspaceSelectionBarZIndexClass = ({
  isWorkspaceNavPushMode,
  ui2026,
}: GetWorkspaceSelectionBarZIndexClassParams) => (isWorkspaceNavPushMode || ui2026 ? 'z-40' : 'z-portal');
